module.exports = __webpack_public_path__ + "img/yiliao1.281ffc5b.png";